module.exports = __webpack_public_path__ + "static/login-146ebc42ad35737dca0d0fc77b04d294.mp4";